export const NATIONALITY = [
    { id: "V", name: "V" },
    { id: "E", name: "E" },
    { id: "P", name: "P" },
  ];